module.exports = __webpack_public_path__ + "static/media/greenBack1.fbe16256.jpg";